// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 351 ? "commons" : chunkId) + "." + {"351":"b40685ad","450":"31d6cfe0"}[chunkId] + ".chunk.css";
};